import React, { FunctionComponent } from 'react';
import { IBlogArticleItem } from '../blog-article-list-item/blog-article-list-item';
import { FeaturedArticleItem } from './featured-article-item/featured-article-item';
import { FeaturedArticlesNav } from './featured-articles-nav/featured-articles-nav';
import { useSwipeable } from 'react-swipeable';
import { State, Action, ActionTypes } from './types';
import styles from './featured-articles.module.scss';

export interface IFeaturedArticlesProps {
  title: string;
  articles: IBlogArticleItem[];
}

const initialState: State = { activeArticle: 0, animating: false };

export const FeaturedArticles: FunctionComponent<IFeaturedArticlesProps> = props => {
  const { title, articles } = props;
  const [state, dispatch] = React.useReducer(reducer, initialState);

  const changeArticleHandler = (event: React.MouseEvent<HTMLElement>): void => {
    const elem = event.currentTarget as HTMLDivElement;
    const index = elem.dataset.index || 0;

    +index !== state.activeArticle &&
      dispatch({ type: ActionTypes.CLICK, item: +index });
  };

  const swipeHandler = (dir: ActionTypes.NEXT | ActionTypes.PREV): void => {
    dispatch({ type: dir, numItems: articles.length - 1 });
  };

  const handlers = useSwipeable({
    onSwipedLeft: () => swipeHandler(ActionTypes.NEXT),
    onSwipedRight: () => swipeHandler(ActionTypes.PREV),
    preventDefaultTouchmoveEvent: true,
    trackMouse: true
  });

  return (
    <div className={styles.container} {...handlers}>
      <div className={styles.articles}>
        {articles.map(
          (article: IBlogArticleItem, i) =>
            i === state.activeArticle && (
              <FeaturedArticleItem
                isAnimated={state.animating}
                {...article}
                key={i}
              />
            )
        )}
        <div className={styles.nav}>
          <FeaturedArticlesNav
            title={title}
            items={articles.map((article, i) => i)}
            changeArticleHandler={changeArticleHandler}
            activeArticle={state.activeArticle}
          />
        </div>
      </div>
    </div>
  );
};

function reducer(state: State, { type, item, numItems }: Action): State {
  switch (type) {
    case ActionTypes.CLICK:
      return {
        ...state,
        animating: true,
        activeArticle: item || item === 0 ? item : state.activeArticle
      };
    case ActionTypes.PREV:
      return {
        ...state,
        animating: true,
        activeArticle:
          state.activeArticle !== 0
            ? state.activeArticle - 1
            : state.activeArticle
      };
    case ActionTypes.NEXT:
      return {
        ...state,
        animating: true,
        activeArticle:
          state.activeArticle !== numItems
            ? state.activeArticle + 1
            : state.activeArticle
      };
    default:
      return state;
  }
}
